// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2-z46","infoBtn":"quickbooks_infoBtn__2FxFz","formBox":"quickbooks_formBox__3HJek","formFooter":"quickbooks_formFooter__2jTun"};